import { Injectable } from '@angular/core';
import { directus, User } from "../../../directus";
import { readUser, readMe } from "@directus/sdk";

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  user: User | undefined;

  constructor() { }



  async getUser(): Promise<User> {
    //const result = await directus.request(
    //  readUsers({
    //    fields: ['*'],
    //  })
    //);
    //this.user = await directus.request<User>(
    //  readUser('0513b6e8-55f2-4ff5-906c-f1a29d7b983c', {
    //    fields: ['id', 'first_name', 'last_name', 'email', 'password', 'location', 'title', //'description', 'tags', 'avatar', 'language', 'appearance', 'tfa_secret', 'status', 'role', //'token', 'last_access', 'last_page'],
    //  })
    //);
    if (!this.user) {
      this.user = await directus.request<User>(
        readMe({
          fields: ['id', 'first_name', 'last_name', 'email', 'password', 'location', 'title', 'description', 'tags', 'avatar', 'language', 'appearance', 'tfa_secret', 'status', 'role', 'token', 'last_access', 'last_page'],
        })
      );
    }
    return this.user;

  }
}
